import { z } from "zod";

export const minimumAssuranceSchema = z.enum(["authenticated", "phishing_resistant", "approved_federation"]);
export const editableRequirementSchema = z.enum(["authenticated", "phishing_resistant", "approved_federation"]).nullable();
export const assignmentSchema = z.object({
  application_id: z.string().uuid(),
  name: z.string(),
  protocol: z.string(),
  status: z.enum(["active", "disabled"]),
  minimum_assurance: minimumAssuranceSchema.nullable(),
});
export const assignmentsPageSchema = z.object({
  version: z.number().int().nonnegative(),
  items: z.array(assignmentSchema),
  next_cursor: z.string().uuid().optional(),
});
export const assignmentWriteSchema = z.object({
  version: z.number().int().nonnegative(),
  minimum_assurance: editableRequirementSchema,
});
export const applicationAccessSearchSchema = z.object({
  appCursor: z.string().uuid().optional(),
});
export type ApplicationAssignment = z.infer<typeof assignmentSchema>;
export type AssignmentWrite = z.infer<typeof assignmentWriteSchema>;
export const requirementLabels = {
  authenticated: "Any enabled sign-in method",
  phishing_resistant: "Verified passkey",
  approved_federation: "Customer identity provider required",
} as const;
